<template>
  <div class="container-fluid-full">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="page-title m-b-none">
            <h1>
              Run Consignment Details
              <span class="status status-success">{{ deliveryRun.status }}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <validation-observer tag="div" class="run-main" v-slot="{ validate }" ref="validator">
      <div class="run-left">
        <div class="run-left-top">
          <div class="border-bottom p-sm">
            <div class="row">
              <div class="col-xs-2">
                <button type="button" class="btn btn-white" @click="previousStop">
                  <font-awesome :icon="['far' ,'chevron-left']"/>
                </button>
              </div>
              <div class="col-xs-8">
                <p class="text-center text-truncate m-b-none">
                  <strong class="small">Stop {{ currentStop.order }} of {{ totalStops }}</strong><br />
                  {{ currentStop.station.name }}
                  <span class="badge badge-green" v-if="currentStop.complete">Complete</span>
                </p>
              </div>
              <div class="col-xs-2 text-right">
                <button type="button" class="btn btn-white" @click="nextStop">
                  <font-awesome :icon="['far' ,'chevron-right']"/>
                </button>
              </div>
            </div>
          </div>
          <div class="p-sm">
            <p class="strong" v-if="currentStop.linked_station">
              <font-awesome :icon="['far' ,'link']"/>
              {{ currentStop.linked_station }}
            </p>
            <div class="form-group">
              <p>
                <strong>Address</strong><br />
                <span v-if="currentStop.station.use_firefighter_address" class="text-danger">
                  EMPLOYEE PERSONAL ADDRESS
                </span>
                <span v-else>{{ currentStop.station.address }}</span>
              </p>
              <p>
                <strong>Garments</strong><br />
                {{ currentStop.dropoff }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="run-right consignment">
        <div class="portlet portlet-default">
          <div class="portlet-heading">
            <div class="portlet-title"><h4>Packing Details</h4></div>
            <div class="clearfix"></div>
          </div>
          <ul class="list-data list-data-consignment no-hover">
            <li class="data-heading visible-lg">
              <div class="row">
                <div class="col-lg-4">Type</div>
                <div class="col-lg-4">Weight (kg)</div>
                <div class="col-lg-4">Dimensions (cm)</div>
              </div>
            </li>
            <run-sheet-container
              v-for="(container, index) in containers"
              :key="`${currentStop.id}.${index}`"
              v-bind="{ container, index, currentStop }"
              :disabled="currentStop.complete"
              @input="updateContainer"
              @remove="removeContainer" />
            <li v-if="currentStop.complete === false">
              <div class="row">
                <validation-provider ref="containers" tag="div" class="col-lg-4" name="containers" v-slot="{ errors }">
                  <multiselect
                    :options="containerOptions"
                    :show-labels="false"
                    label="name"
                    @input="addContainer"
                  />

                  <help-block v-bind="{ errors }" class="help-block text-danger" />
                </validation-provider>
              </div>
            </li>
          </ul>
        </div>
        <div class="text-right">
          <ladda-button type="button" class="btn btn-info" v-if="currentStop.complete === false" :click="saveDraft" v-bind="{ validate, failed }">
            Save Draft
          </ladda-button> <ladda-button type="button" class="btn btn-success" :click="saveDispatch" v-bind="{ validate, failed }" v-if="currentStop.complete === false">
            Save &amp; Dispatch
          </ladda-button> <ladda-button type="button" class="btn btn-success" :click="printConsignment" v-if="currentStop.complete === true">
            Print Con Note(s)
          </ladda-button>
        </div>
      </div>
    </validation-observer>

    <add-garment-to-run-modal :id="deliveryRun.id" @hidden="addGarmentToRunClose"></add-garment-to-run-modal>
  </div>
</template>

<script>
import { get, sync, call } from 'vuex-pathify'
import { validation } from 'mixins'
import { handleServerErrors } from 'utils'
import RunSheetContainer from '@/components/delivery-runs/RunSheetContainer.vue'
import AddGarmentToRunModal from './AddGarmentToRunModal'

export default {
  mixins: [validation],

  components: {
    RunSheetContainer,
    AddGarmentToRunModal
  },

  data () {
    return {
      currentStopIndex: 0,
      containerOptions: [
        { name: 'Satchel', type: 'satchel', length: 39, width: 27, height: 10 },
        { name: 'Box', type: 'box', length: 44, width: 28, height: 17 },
        { name: 'Custom', type: 'custom', length: null, width: null, height: null }
      ],
      containers: [],
      unwatchContainers: null
    }
  },

  beforeDestroy () {
    this.resetDeliveryRun()
  },

  computed: {
    deliveryRun: get('deliveryRuns/deliveryRun'),
    stops: sync('deliveryRuns/deliveryRun@stops'),

    currentStop () {
      return this.stops[this.currentStopIndex]
    },

    totalStops () {
      return this.stops.length
    }
  },

  watch: {
    currentStopIndex: {
      handler () {
        if (this.unwatchContainers) {
          this.unwatchContainers()
          this.unwatchContainers = null
        }

        this.containers = [...this.currentStop.containers]

        this.watchContainers()
      },
      immediate: true
    }
  },

  methods: {
    getDeliveryRun: call('deliveryRuns/getDeliveryRun'),
    resetDeliveryRun: call('deliveryRuns/resetDeliveryRun'),
    updateDeliveryRunStopContainers: call('deliveryRuns/updateDeliveryRunStopContainers'),
    printDeliveryRunStopConsignment: call('deliveryRuns/printDeliveryRunStopConsignment'),

    previousStop () {
      if (this.currentStopIndex === 0) {
        this.currentStopIndex = this.stops.length - 1
      } else {
        this.currentStopIndex--
      }
    },

    nextStop () {
      if (this.currentStopIndex === this.stops.length - 1) {
        this.currentStopIndex = 0
      } else {
        this.currentStopIndex++
      }
    },

    failed (error) {
      if (error.response && error.response.status === 422) {
        handleServerErrors(error, this.$refs.validator)
      }
    },

    watchContainers () {
      if (this.unwatchContainers) {
        return
      }

      this.unwatchContainers = this.$watch('containers', this.saveDraft, { deep: true })
    },

    async saveDraft () {
      await this.updateDeliveryRunStopContainers({
        deliveryRun: this.deliveryRun,
        stop: this.currentStop,
        payload: {
          dispatch: false,
          containers: this.containers
        }
      })

      this.rewatchContainers()
    },

    rewatchContainers () {
      // Stop watching the containers so we can set the watch up again.
      if (this.unwatchContainers) {
        this.unwatchContainers()
        this.unwatchContainers = null
      }

      this.containers = [...this.currentStop.containers]
      this.watchContainers()
    },

    async saveDispatch () {
      try {
        await this.updateDeliveryRunStopContainers({
          deliveryRun: this.deliveryRun,
          stop: this.currentStop,
          payload: {
            dispatch: true,
            containers: this.containers
          }
        })

        await this.getDeliveryRun(this.deliveryRun.id)

        // Stop watching the containers, no need to watch again because they cannot be changed.
        if (this.unwatchContainers) {
          this.unwatchContainers()
        }

        this.containers = [...this.currentStop.containers]
      } catch (error) {
        if (error.response) {
          if (error.response.status === 400) {
            this.$notify('error', error.response.data.message)

            return
          }
        }

        throw error
      }
    },

    async printConsignment () {
      await this.printDeliveryRunStopConsignment({
        deliveryRun: this.deliveryRun,
        stop: this.currentStop
      })

      this.$notify('success', 'Consignment notes have been sent to the printer.')
    },

    async addGarmentToRunClose () {
      await this.getDeliveryRun(this.deliveryRun.id)

      this.rewatchContainers()
    },

    updateContainer (container, index) {
      this.containers.splice(index, 1, container)
    },

    removeContainer (index) {
      this.containers.splice(index, 1)
    },

    addContainer (container) {
      this.containers.push({
        type: container.type,
        weight: null,
        width: container.width,
        length: container.length,
        height: container.height
      })

      this.$refs.containers.reset()
    }
  }
}
</script>
